import { useMutation } from "@tanstack/react-query";
import { removePatientFromMedicalUserApi } from "../../../utils/apis/medical-user-service";

export const useRemovePatientFromMedicalUser = () => {
    return useMutation({
        mutationFn: async ({ idToken, medicalUserId, patientId, onSuccess, onError, handleSessionExpiry }: {
            idToken: string,
            medicalUserId: string,
            patientId: string,
            onSuccess: () => void,
            onError: (error: string) => void,
            handleSessionExpiry?: () => void
        }) => {
            return removePatientFromMedicalUserApi(
                idToken,
                medicalUserId,
                patientId,
                onSuccess,
                onError,
                handleSessionExpiry
            );
        },
        onSuccess: () => {
            console.log("Patient successfully removed from the medical user.");
        },
        onError: (error) => {
            console.error("Error removing patient:", error);
        }
    });
};